import "../styles/Creation.scss";
import creation from "../assets/creationx.gif";
import Zoom from "react-reveal/Zoom";
import useLightbox from "../hooks/useLightbox";
import img01 from "../assets/creations/margot-tita.jpg";
import img02 from "../assets/creations/margot-tita-02.jpg";
import img03 from "../assets/creations/margot-tita-03.jpg";
import img04 from "../assets/creations/margot-tita-04.jpg";
import img05 from "../assets/creations/margot-tita-05.jpg";
import img06 from "../assets/creations/margot-tita-06.jpg";
import img07 from "../assets/creations/margot-tita-07.jpg";
import img08 from "../assets/creations/margot-tita-08.jpg";
import img09 from "../assets/creations/heineken.jpg";
import img10 from "../assets/creations/stan smith.jpg";
import img11 from "../assets/creations/oreo.jpg";
import img13 from "../assets/creations/nike-air-max.jpg";
import img14 from "../assets/creations/nike-phenom.jpg";
import img15 from "../assets/creations/tattoo.png";
import img16 from "../assets/creations/retro-is-better.jpg";
import img17 from "../assets/creations/dim-chris-feat-craig-david.jpg";
import img18 from "../assets/creations/captain morgan.jpg";
import img19 from "../assets/creations/happyuncle.jpg";
import img20 from "../assets/creations/nintendo.jpg";

const shuffle = (arr) => {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
};

const ALL_CARDS = shuffle([
  { img: img01, title: "Margot & Tita" },
  { img: img02, title: "Margot & Tita" },
  { img: img03, title: "Margot & Tita" },
  { img: img04, title: "Margot & Tita" },
  { img: img05, title: "Margot & Tita" },
  { img: img06, title: "Margot & Tita" },
  { img: img07, title: "Margot & Tita" },
  { img: img08, title: "Margot & Tita" },
  { img: img09, title: "Heineken" },
  { img: img10, title: "Stan Smith" },
  { img: img11, title: "Oreo" },
  { img: img13, title: "Nike Air Max" },
  { img: img14, title: "Nike Phenom" },
  { img: img15, title: "Tattoo" },
  { img: img16, title: "Retro is Better" },
  { img: img17, title: "Dim / Chris feat Craig David" },
  { img: img18, title: "Captain Morgan" },
  { img: img19, title: "Happy Uncle" },
  { img: img20, title: "Nintendo" },
]);

const Creation = () => {
  const { lightbox, visible, openLightbox, closeLightbox } = useLightbox();

  return (
    <div className="boxCreation">
      <section id="sectionCreation"></section>
      <div className="boxTitle">
        <img src={creation} alt="imgCreation" className="imgCreation"></img>
      </div>

      {ALL_CARDS.map(({ img, title }, i) => (
        <Zoom key={i}>
          <div className="boxText">
            <h1>{title}</h1>
            <div className="gridContainer" onClick={() => openLightbox(img)} style={{ cursor: "pointer" }}>
              <img src={img} alt="" className="imgGrid" />
            </div>
          </div>
        </Zoom>
      ))}

      {lightbox && (
        <div className={`lightbox${visible ? " lightbox--visible" : ""}`} onClick={closeLightbox}>
          <img src={lightbox} alt="" className="lightbox__img" onClick={closeLightbox} />
        </div>
      )}
    </div>
  );
};

export default Creation;
